import { bindGeTui } from "@/api/shop";
import router from "@/router";
import { Notification } from "element-ui";
// 是否打开调试模式
let debugMode = process.env.NODE_ENV !== "production";
/**
 * 推送管理器
 * @author huawei
 * 配置通知跳转路径
 */
const pushPathConfig = {
  21: {
    path: "/compliance/compliance-checkchildtask-list",
    title: "有新的待审核子任务，请您及时处理",
  }, //有新的待审核子任务，请您及时处理 | 有新的待审核的子任务 ｜ 平台端有“合规管理-审核指标子任务页面”权限的用户 ｜ 跳转 审核指标子任务页面
  31: {
    path: "/compliance/compliance-checkSalesman-personCertifyCheckList",
    title: "有新的待审核人员资质，请您及时处理",
  }, //有新的待审核人员资质，请您及时处理 | 有新的待审核人员资质 ｜ 平台端有“合规管理-审核人员资质”权限的用户 ｜ 跳转 审核人员资质页面
  32: {
    path: "/compliance/compliance-checkSalesman-list",
    title: "有新的待审核业务员，请您及时处理",
  }, //有新的待审核业务员，请您及时处理 | 有新的待审核业务员 ｜ 平台端有“合规管理-审核业务员”权限的用户 ｜ 跳转 审核业务员页面
};
let GtPushManager = (function () {
  let instance = null;

  function GtPushManager() {
    if (instance) {
      return instance;
    }

    this.cid = null;
    instance = this;
  }

  GtPushManager.prototype.init = function (doctorId) {
    // if (!doctorId) {
    //   console.error("Doctor ID is required for initialization.");
    //   return;
    // }

    GtPush.setDebugMode(debugMode);
    GtPush.init({
      appid: "yJRPBAq9DV7nh5DkGgwR75",
      onClientId: (res) => {
        console.log(`gtpush onClientId: ${res.cid}`);
        this.cid = res.cid;
        GtPush.enableSocket(true); // 打开socket连接
        let oldCid = localStorage.getItem("gtpush_cid");
        let data = {
          oldCid: oldCid || "", // 上一次绑定的cid,让后端可以清理冗余数据
          cid: res.cid,
          source: "0", // 0: pc, 1: app
          isAdmin: true, //是否是管理员
        };
        bindGeTui(data)
          .then((res) => {
            console.log(`gtpushBind: ${res}`);
            localStorage.setItem("gtpush_cid", this.cid);
          })
          .catch((err) => {
            console.error("Failed to bind client ID with doctor:", err);
          });
      },
      onlineState: (data) => {
        console.log(`gtpush onlineState: ${data.online}`);
      },
      onPushMsg: (res) => {
        if (!res.message) {
          console.error("No message received in onPushMsg.");
          return;
        }

        console.log(`onPushMsg gtpush onPushMsg`, res.message);
        let messageObj = {};

        try {
          messageObj = JSON.parse(res.message);
        } catch (ex) {
          console.error("Failed to parse message:", ex);
          return;
        }
        // 进一步处理 messageObj
        // pushPathConfig
        const { type } = messageObj;
        if (type) {
          const { path, title } = pushPathConfig[type];
          if (path) {
            const noti = Notification({
              title: "提示",
              message: title,
              duration: 0,
              onClick: () => {
                router.push({ path });
                noti.close();
              },
            });
          }
        }
      },
      onError: (res) => {
        console.error(`gtpush onError`, res.error);
      },
    });
  };

  GtPushManager.prototype.offline = function () {
    console.log("gtpush offline");
    this.cid = null;
    instance = null;
    GtPush.enableSocket(false); // 关闭socket连接
  };

  return GtPushManager;
})();

export { GtPushManager };
